import { Directive, HostListener, Optional } from '@angular/core';
import { DropdownComponent } from '@shared/components/dropdown/dropdown.component';

@Directive({
  selector: '[appDropdownClose]',
  standalone: true,
})
export class DropdownCloseDirective {
  constructor(@Optional() private dropdown: DropdownComponent) {}

  @HostListener('click')
  handleClick() {
    this.dropdown?.close();
  }
}
